import { motion } from 'framer-motion'
import styled from 'styled-components/macro'
import { styleReset } from 'styles/misc'
import Mask from 'assets/mask.png'

export const Modal = styled(motion.div)`
  position: fixed;
  inset: 0;
  padding-block: var(--container-spacing);
  backdrop-filter: blur(5px);
  background-color: rgba(230, 230, 230, 0.9);
  z-index: 12;

  img {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const CloseBtn = styled(motion.div)`
  ${styleReset}
  position: absolute;
  top: var(--container-spacing);
  right: var(--container-spacing);
  color: white;
  cursor: pointer;
  mask: url('${Mask}') center top;

  &::before {
    content: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 22C9.34711 22.0024 6.80218 20.9496 4.9263 19.0737C3.05042 17.1978 1.99762 14.6529 2 12V11.8C2.08179 7.79223 4.5478 4.22016 8.26637 2.72307C11.9849 1.22597 16.2381 2.0929 19.074 4.92601C21.9365 7.78609 22.7932 12.0893 21.2443 15.8276C19.6955 19.5659 16.0465 22.0024 12 22ZM12 13.41L14.59 16L16 14.59L13.41 12L16 9.41001L14.59 8.00001L12 10.59L9.41001 8.00001L8.00001 9.41001L10.59 12L8.00001 14.59L9.41001 16L12 13.411V13.41Z' fill='black'/%3E%3C/svg%3E%0A");
    display: block;
    width: 3rem;
    height: 3rem;
  }
`
